import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Equipment, Combination, Implement, Implant } from './models/Equipment';
import { PriceItem, Price } from './models/Price';
import { Worker } from './models/Worker';
import { Seed } from './models/Seed';
import { Product } from './models/Product';
import { Fertilizer } from './models/Fertilizer';
import { Phytochemical } from './models/Phytochemical';
import { Stock } from './models/Stock';
import { Action } from "@abaco/activities-module/src/modules/activities-module/models/Action";
import { Fuel } from "./models/Fuel";
import { Electricity } from "./models/Electricity";
import { Water } from "./models/Water";

export default class CostsRevenuesVuexModule extends AbacoVuexModule {

    @State() curEntityCode!: string | null;
    @State() curAction!: Action | null;
    @State() curEquipment!: Equipment | null;
    @State() curCombination!: Combination | null;
    @State() curImplement!: Implement | null;
    @State() curImplant!: Implant | null;
    @State() curWorker!: Worker | null;
    @State() curSeed!: Seed | null;
    @State() curProduct!: Product | null;
    @State() curFertilizer!: Fertilizer | null;
    @State() curPhytochemical!: Phytochemical | null;
    @State() curStock!: Stock | null;
    @State() curFuel!: Fuel | null;
    @State() curElectricity!: Electricity | null;
    @State() curWater!: Water | null;

    @State() curPriceItem!: PriceItem | null;
    @State() curPrice!: Price | null;

    @State() canViewCost!: boolean;
    @State() canEditCost!: boolean;
    @State() canEditAction!: boolean;
}
